import { ThemeEvents } from '@theme/events';

class ProductMediaGallery extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  updateMediaGallery = (event) => {
    const newMediaGallery = event.detail.data.html.querySelector('product-media-gallery');

    if (!newMediaGallery) return;

    // Keep the visible slider and its zoom dialog in the same media order.
    // Variant media is moved first by Liquid, so replacing only the slider
    // leaves the zoom gallery pointing at the previous variant's media.
    if (this.innerHTML !== newMediaGallery.innerHTML) {
      this.replaceChildren(...Array.from(newMediaGallery.childNodes));
    }
  };
}

if (!customElements.get('product-media-gallery')) {
  customElements.define('product-media-gallery', ProductMediaGallery);
}
